import _i18n from '../../../i18n/index';

/**
 * Helper function for parsing the i18n for a key/value and
 * returning that value.
 * @param  {String} path ex. "example.header"
 * @return {String}      i18n Lookup for path provided
 */
export default function(path) {
  try {
    var obj = _i18n;
    path = path.split('.');
    for (var i = 0; i < path.length; i++){
        obj = obj[path[i]];
    }
    return obj;
  } catch(e) {
    return 'undefined';
  }
}



// WEBPACK FOOTER //
// ./src/scripts/helpers/i18n.js